'use client';

import { useActionState } from 'react';
import { registerAction } from '@/lib/auth/auth.actions';

interface RegisterFormProps {
  labels?: {
    fullNameLabel?: string;
    passwordLabel?: string;
    submitLabel?: string;
    pendingLabel?: string;
    passwordPlaceholder?: string;
  };
}

export function RegisterForm({ labels }: RegisterFormProps) {
  const [state, action, isPending] = useActionState(registerAction, undefined);

  const fullNameLabel       = labels?.fullNameLabel       ?? 'Full name';
  const passwordLabel       = labels?.passwordLabel       ?? 'Password';
  const submitLabel         = labels?.submitLabel         ?? 'Create Account';
  const pendingLabel        = labels?.pendingLabel        ?? 'Creating account...';
  const passwordPlaceholder = labels?.passwordPlaceholder ?? 'Min. 8 characters';

  return (
    <form action={action} className="space-y-4">
      {state?.error && (
        <div className="badge-red w-full py-2 px-3 rounded-lg text-sm">
          {state.error}
        </div>
      )}

      <div>
        <label htmlFor="name" className="label">{fullNameLabel}</label>
        <input id="name" name="name" type="text" required className="input" placeholder="Jane Smith" />
      </div>

      <div>
        <label htmlFor="email" className="label">Email</label>
        <input id="email" name="email" type="email" autoComplete="email" required className="input" placeholder="hello@example.com" />
      </div>

      <div>
        <label htmlFor="password" className="label">{passwordLabel}</label>
        <input id="password" name="password" type="password" required minLength={8} className="input" placeholder={passwordPlaceholder} />
      </div>

      <button type="submit" disabled={isPending} className="btn-primary w-full btn-lg">
        {isPending ? (
          <span className="flex items-center gap-2">
            <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            {pendingLabel}
          </span>
        ) : submitLabel}
      </button>
    </form>
  );
}
